import React from "react"
import { Grid, Typography } from "@mui/material"
import CountUp from "react-countup"
import { useInView } from "react-intersection-observer"
import { size, COLORS } from "../../utils"
import styles from "./Success.module.css"

export default function Success() {
    const DATA = {
        1: { count: 11, suffix: '+', text: 'Years Experience' },
        2: { count: 10000, suffix: '+', text: 'Students Certified' },
        3: { count: 5000, suffix: '+', text: 'Projects Delivered' },
        4: { count: 8000, suffix: '+', text: 'Students Mentored' },
        5: { count: 500, suffix: '+', text: 'Research Assistance' },
    }

    // This hook tracks if the section is visible in viewport
    const { ref, inView } = useInView({
        triggerOnce: true, // animate only once
        threshold: 0.3, // how much of the section should be visible before triggering
    })

    return (
        <Grid
            ref={ref}
            item
            container
            flexWrap={'nowrap'}
            direction={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            width={size({ p: 75 })}
            rowGap={size({ p: 2, h: true })}
            mt={size({ p: 15, h: true })}
            height={size({ p: 30, h: true })}
            sx={{
                background: `radial-gradient(63.24% 50% at 50% 0%,rgba(255,255,255,.48) 0%,rgba(255,255,255,0) 100%),${COLORS.C1}`,
                backgroundBlendMode: 'overlay,normal',
                padding: `0px ${size({ p: 2 })}`,
                borderRadius: size({ p: 1.5 })
            }}
            className={styles['success-container']}
        >
            <Grid item>
                <Typography
                    sx={{
                        fontFamily: 'Archia',
                        fontSize: size({ p: 2.1 }),
                        fontWeight: 600,
                        color: COLORS.WHITE,
                    }}
                    className={styles['success-title']}
                >
                    What we achieved so far?
                </Typography>
            </Grid>

            <Grid item container flexWrap={'nowrap'}>
                {Object.keys(DATA).map((k, i) => {
                    const item = DATA[k]
                    return (
                        <Grid
                            key={i}
                            item
                            container
                            flexWrap={'nowrap'}
                            direction={'column'}
                            pl={size({ p: 2 })}
                        >
                            <Grid item>
                                <Typography
                                    sx={{
                                        fontFamily: 'Archia',
                                        fontSize: size({ p: 2.6 }),
                                        fontWeight: 600,
                                        color: COLORS.WHITE + 'E0',
                                        mt: '1rem'
                                    }}
                                    className={styles['success-number']}
                                >
                                    {inView ? (
                                        <CountUp
                                            start={0}
                                            end={item.count}
                                            duration={2.5}
                                            separator=","
                                        />
                                    ) : (
                                        0
                                    )}
                                    {item.suffix}
                                </Typography>
                            </Grid>

                            <Grid item>
                                <Typography
                                    sx={{
                                        fontFamily: 'Space Mono',
                                        fontSize: size({ p: 0.93 }),
                                        fontWeight: 'bold',
                                        color: COLORS.WHITE + 'A0',
                                    }}
                                    className={styles['success-label']}
                                >
                                    {item.text}
                                </Typography>
                            </Grid>
                        </Grid>
                    )
                })}
            </Grid>
        </Grid>
    )
}
